// App.js
import React from 'react';
import AppRouter from './components/Router';
import { ToastContainer } from 'react-toastify';

function App() {
  const backgroundImageUrl =
  'https://www.google.com/url?sa=i&url=https%3A%2F%2Funsplash.com%2Fs%2Fphotos%2Frandom&psig=AOvVaw1QlDMSPPI5D5Drsx2iTCrU&ust=1707049107158000&source=images&cd=vfe&opi=89978449&ved=0CBMQjRxqFwoTCLD1svKVj4QDFQAAAAAdAAAAABAE';
  return (
    <div>
      <ToastContainer/>
      <AppRouter />
    </div>
  );
}

export default App;
